var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGnosisIconGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 600,
    rx: 300,
    fill: "#04795B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M218.491 327.173C230.306 327.173 241.213 323.236 249.999 316.422L177.893 244.342C171.076 252.973 167.138 263.876 167.138 275.839C166.986 304.156 190.012 327.173 218.491 327.173Z",
    fill: "#EFEFEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M432.99 275.687C432.99 263.876 429.052 252.973 422.235 244.19L350.129 316.27C358.763 323.084 369.67 327.021 381.637 327.021C409.965 327.173 432.99 304.156 432.99 275.687Z",
    fill: "#EFEFEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M469.346 197.4L437.383 229.351C447.987 242.071 454.349 258.123 454.349 275.991C454.349 316.119 421.78 348.676 381.637 348.676C363.914 348.676 347.705 342.316 334.98 331.716L299.988 366.696L264.995 331.716C252.271 342.316 236.213 348.676 218.338 348.676C178.195 348.676 145.627 316.119 145.627 275.991C145.627 258.274 151.989 242.071 162.593 229.351L146.232 212.997L130.63 197.4C112.452 227.383 102 262.363 102 299.917C102 409.247 190.617 497.681 299.836 497.681C409.056 497.681 497.673 409.096 497.673 299.917C497.976 262.211 487.524 227.231 469.346 197.4Z",
    fill: "#EFEFEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M443.139 163.328C407.238 125.623 356.339 102 299.988 102C243.636 102 192.889 125.623 156.836 163.328C151.989 168.477 147.293 173.928 142.9 179.531L299.836 336.41L456.773 179.38C452.834 173.928 448.138 168.325 443.139 163.328ZM299.988 127.743C346.342 127.743 389.363 145.611 421.629 178.168L299.988 299.764L178.347 178.168C210.764 145.611 253.634 127.743 299.988 127.743Z",
    fill: "#EFEFEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnosisIconGreen);
export default __webpack_public_path__ + "static/media/gnosis-icon-green.90512ab9f6bb0735cf52d3288bc6e66e.svg";
export { ForwardRef as ReactComponent };